declare var swal: any;
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, GuardianInfoController, GuardianInfoRequest, SaveCustomerMessageRequest, CustomerMessageRequest, CustomerMessageController, OTFormDetailByReportCodeController, OTFormDetailByReportCodeRequest, SectionData, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, FollicularScansByCycleController, FollicularScansByCycleRequest, FollicularScanDetailsByCodeController, FollicularScanDetailsByCodeRequest, FollicularScanDetailController, FollicularScanDetailRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest } from '../../../../models/actor/actor';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//import { NgbdUploadActorImageModal } from '../../../../../modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorPersonalInfoController, ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppFeaturesList } from '../../../../constants/constants';
//import  './profilesteps.js';
import { HCPService } from '../../../../services/hcp.service';
declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { NgbTcDetailsModal } from './tcdetails.modal';
import { NgbEventAddModal } from './eventadd.modal';
import { FdActorReportsDocController, FDActorDocRequest } from '../../../../../../../src/app/ncs/models/formdesign/fd.model';
import { FDService } from '../../../../../../../src/app/ncs/services/fd.service';
import { NgbViewMedicineTestModal } from './viewmedicinetest.modal';
import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

@Component({
  selector: 'follicularscan',
  templateUrl: './follicularscan.component.html',
  styleUrls: ['./follicularscan.component.scss'],
  animations: [routerTransition()]
})

export class FollicularScanComponent implements OnInit {

  //Variable Declaration
  currentPage: string = "About"
  public isRequesting: boolean = false;

  //CurrentFdActorReportsDocController: FdActorReportsDocController[];
  //CurrentFDActorDocRequest: FDActorDocRequest;
  public ApiResData: ApiResponseModel;



  @Input() NurseActorCode: number = 0;
  @Input() ActorCode: number;
  @Input() CycleCode: number;
  @Input() Duration: number;
  @Input() FormattedCode: number;
  @Input() DisplayName: string;
  searchTitle: string;
  //
  //public FormattedCode: number = 0;
  public IsSetAccessRights: boolean;
  public CanEditProfileInfo: number = 0;
  public CanEditContactInfo: number = 0;
  public CanShowProfileInfo: number = 0;
  public CanShowContactInfo: number = 0;
  public Code: string;

  public CanShowProfileSummary: number = 0;
  public CanEditProfileSummary: number = 0;

  public CanShowJobPreferences: number = 0;
  public CanEditJobPreferences: number = 0;

  public CanShowEducation: number = 0;
  public CanEditEducation: number = 0;

  public CanShowEmploymentHistory: number = 0;
  public CanEditEmploymentHistory: number = 0;

  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;

  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;

  public CanShowCertifications: number = 0;
  public CanEditCertifications: number = 0;

  public CanShowMedicalFitness: number = 0;
  public CanEditMedicalFitness: number = 0;

  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;

  public CanShowLegalinfo: number = 0;
  public CanEditLegalinfo: number = 0;
  public showprofile: boolean = true;
  public showmessages: boolean = false;
  public LMPDate: Date;
  //
  CurrentFollicularScanDetailController: FollicularScanDetailController[];
  FollicularScanEndInfo: FollicularScanDetailController;
  CurrentFollicularScanDetailRequest: FollicularScanDetailRequest;

  LoadScansData() {
    //alert("ScansData")
    this.CurrentFollicularScanDetailRequest = new FollicularScanDetailRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentFollicularScanDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetFollicularScanDetailController();
  }

  GetFollicularScanDetailController() {
    this.StartRefreshing();
    this.CurrentFollicularScanDetailRequest.ConditionalOperator = 20;
    this.CurrentFollicularScanDetailRequest.ScanCode = 0;
    this.CurrentFollicularScanDetailRequest.CycleCode = this.CycleCode;
    this.CurrentFollicularScanDetailRequest.PatientCode = 0;

    //alert(this.FormattedCode);
    this.actorservice.GetFollicularScanDetailController(this.CurrentFollicularScanDetailRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFollicularScanDetailController = this.ApiResData.Result;
          this.FollicularScanEndInfo = this.CurrentFollicularScanDetailController[0];


          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();

          this.LoadOvaryData();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentFollicularScanOvaryDetailController: FollicularScanOvaryDetailController[];
  FollicularScanInfo: FollicularScanOvaryDetailController;
  CurrentFollicularScanOvaryDetailRequest: FollicularScanOvaryDetailRequest;

  LoadOvaryData() {
    //alert("ScansData")
    this.CurrentFollicularScanOvaryDetailRequest = new FollicularScanOvaryDetailRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentFollicularScanOvaryDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetFollicularScanOvaryDetailController();
  }

  GetOvaryDetails(fg: number, pos: string): FollicularScanOvaryDetailController[] {
    return this.CurrentFollicularScanOvaryDetailController.filter(
      function (v, i, d) {
        return v.FollicularGrowth == fg && v.OvarPos == pos;
      }
    );

  }


  GetFollicularScanOvaryDetailController() {
    this.StartRefreshing();
    this.CurrentFollicularScanOvaryDetailRequest.ConditionalOperator = 20;
    this.CurrentFollicularScanOvaryDetailRequest.ScanCode = 0;
    this.CurrentFollicularScanOvaryDetailRequest.CycleCode = this.CycleCode;
    this.CurrentFollicularScanOvaryDetailRequest.PatientCode = 0;

    //alert(this.FormattedCode);
    this.actorservice.GetFollicularScanOvaryDetailController(this.CurrentFollicularScanOvaryDetailRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFollicularScanOvaryDetailController = this.ApiResData.Result;
          this.FollicularScanInfo = this.CurrentFollicularScanOvaryDetailController[0];
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;

  CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
  LoadPatients() {
    this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = this.ActorCode;
    this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesByActorCodeController();
  }

  GetTreatmentCyclesByActorCodeController() {
    this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
          this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
          this.LMPDate = this.SelectedTreatmentCycle.LMP;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadPlan();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router, public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService, private hcpservice: HCPService, private fdservice: FDService, private tosterservice: NGXToastrService,
    private modalService: NgbModal) {

    //stepObject.init();
    //webGlObject.init();
  }


  ngOnInit() {
    this.LoadScansData();
    this.LoadPatients();
    //alert(this.ActorCode);
    //alert(this.CycleCode);
    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');


    //this.LoadPatients();
    ///this.LoadClinics();
    //this.LoadMessages();



    //alert(this.ActorCode);


    // Horizontal Timeline js for user timeline
    //$.getScript('./assets/js/vertical-timeline.js');
    //



  }








  //

  //







  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  closeResult: string;
  // This function is used in open

  // Open content with dark section
  //openContent() {
  //  alert('open dialog');
  //  if (this.CurrentActorProfileController.ActorImageCode != null && this.CurrentActorProfileController.ActorImageCode > 0) {
  //    const modalRef = this.modalService.open(NgbdUploadActorImageModal, {
  //      centered: true
  //    })
  //    modalRef.componentInstance.ActorImageCode = this.CurrentActorProfileController.ActorImageCode;
  //    modalRef.componentInstance.ActorCode = this.CurrentActorProfileController.ActorCode;
  //    modalRef.componentInstance.ActorImageFile == this.CurrentActorProfileController.ActorImageFile;
  //    modalRef.componentInstance.ActorImageFileExtension = this.CurrentActorProfileController.ActorImageFileExtension;

  //    modalRef.result.then(x => { this.GetActorProfileController() })

  //  }
  //  else {
  //    alertFunctions.AlertParam('you dont have Permission to Upload...!');
  //  }
  //}

  SelectGrowthCode(s: FollicularScanDetailController) {
    var FollicularGowthcode = s.FollicularGrowth;
    this.printfollicular(FollicularGowthcode);
  }
  Top() {
    let m = document.querySelector("#top");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  Bottom() {
    let m = document.querySelector("#bottom");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  ViewMedicines() {
    const modalRef = this.modalService.open(NgbViewMedicineTestModal,
      {
        centered: true,
        size: "lg"

      })
    modalRef.componentInstance.CycleCode = this.CycleCode;
    modalRef.componentInstance.ActorCode = this.ActorCode;
    modalRef.componentInstance.ScanDate = this.CurrentFollicularScanDetailController[0].ScanDate;
  }

  printfollicular(FollicularGowthcode: number) {
    this.printService.printDocument("follicularscanstcindi",
      {
        ScanCodeData: this.FollicularScanInfo.FollicularGrowth, FollicularGowthcodeData: FollicularGowthcode, CycleCode: this.FollicularScanInfo.TreatmentCycle, PatientCode: this.FollicularScanInfo.PatientCode, Doc: this.FollicularScanInfo.DOC, DocDate: this.SelectedTreatmentCycle.LMP, CycleActivity: this.FollicularScanInfo.CycleActivity, CycleType: this.SelectedTreatmentCycle.CycleType,
        EggSourceData: this.SelectedTreatmentCycle.EggSourceType, DonorData: this.SelectedTreatmentCycle.EggName, DonorCode: this.SelectedTreatmentCycle.EggFormattedCode, Owner: this.SelectedTreatmentCycle.OwnerName, FormattedCode: this.SelectedTreatmentCycle.OwnerFormattedCode, Protocolst: this.SelectedTreatmentCycle.ProtocolStartDate, ProtocolEd: this.SelectedTreatmentCycle.ProtocolEndDate, Protocol: this.SelectedTreatmentCycle.ProtocolName, Infertility: this.SelectedTreatmentCycle.InfertilityType, Gender: this.SelectedTreatmentCycle.OwnerGender, Age: this.SelectedTreatmentCycle.OwnerAgeYears, CycleNo: this.SelectedTreatmentCycle.CycleNo,

      }

    );
  }
  printfollicular2() {
    this.printService.printDocument("follicularscanstc",
      {
        ScanCodeData: this.FollicularScanInfo.FollicularGrowth, CycleCode: this.FollicularScanInfo.TreatmentCycle, PatientCode: this.FollicularScanInfo.PatientCode, Doc: this.FollicularScanInfo.DOC, DocDate: this.SelectedTreatmentCycle.LMP, CycleActivity: this.FollicularScanInfo.CycleActivity, CycleType: this.SelectedTreatmentCycle.CycleType,
        EggSourceData: this.SelectedTreatmentCycle.EggSourceType, DonorData: this.SelectedTreatmentCycle.EggName, DonorCode: this.SelectedTreatmentCycle.EggFormattedCode, Owner: this.SelectedTreatmentCycle.OwnerName, FormattedCode: this.SelectedTreatmentCycle.OwnerFormattedCode, Protocolst: this.SelectedTreatmentCycle.ProtocolStartDate, ProtocolEd: this.SelectedTreatmentCycle.ProtocolEndDate, Protocol: this.SelectedTreatmentCycle.ProtocolName, Infertility: this.SelectedTreatmentCycle.InfertilityType, Gender: this.SelectedTreatmentCycle.OwnerGender, Age: this.SelectedTreatmentCycle.OwnerAgeYears, CycleNo: this.SelectedTreatmentCycle.CycleNo,

      }

    );
  }
}
